import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import FindPassword from './FindPassword';
import FindId from './FindId';
import { PageContainer } from '../components/common/PageComponent.style';

const Find = () => {
  const location = useLocation();
  const { type, providedUserid, providedPhone, providedName } =
    location.state || {}; // 전체 state 값 가져오기
  useEffect(() => {
    window.scrollTo(0, 0);
    setTab(type || 'id');
  }, []);

  useEffect(() => {
    if (type) {
      setTab(type);
    }
  }, [type]);
  const navigate = useNavigate();

  const [tab, setTab] = useState('');

  const RendingData = (type: string) => {
    if (type === 'password') {
      return (
        <FindPassword
          providedUserid={providedUserid}
          providedPhone={providedPhone}
          providedName={providedName}
        />
      );
    } else {
      return <FindId />;
    }
  };

  return (
    <PageContainer>
      <div
        style={{
          padding: '16px',
        }}
      >
        <img
          onClick={() => {
            navigate(-1);
          }}
          src="/assets/images/arrow/back-arrow-left-gray.svg"
        ></img>
      </div>
      <Inner>
        <Title>아이디 찾기, 비밀번호 찾기</Title>
        <TabBox>
          <TabContent onClick={() => setTab('id')} isActive={tab === 'id'}>
            아이디 찾기
          </TabContent>
          <TabContent
            onClick={() => setTab('password')}
            isActive={tab === 'password'}
          >
            비밀번호 찾기
          </TabContent>
        </TabBox>
        {RendingData(tab)}
      </Inner>
    </PageContainer>
  );
};

export default Find;

interface TabContentProps {
  isActive: boolean;
}

const TabContent = styled.div<TabContentProps>`
  width: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  cursor: pointer;

  color: ${(props) =>
    props.isActive ? 'rgb(34, 34, 34)' : 'rgba(55, 56, 60, 0.61)'};
  border: ${(props) =>
    props.isActive ? '1px solid rgb(225, 226, 228)' : 'none'};
  background-color: ${(props) => (props.isActive ? 'white' : 'none')};
`;

const TabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  // padding: 16px;
  justify-content: center;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.05);
`;

const Title = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 24px;
  font-weight: 700;
  line-height: 34.8px;
  color: #171e26;
`;

const Inner = styled.div`
  width: 100%;
  // max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  gap: 40px;
  margin: 0 auto;
  padding: 40px 16px;
`;
